import React from 'react';

export const InputType = ({name, placeholder, type, label, id, handleInputChange})=>{
    return <div>
        <label htmlFor={id}>{label}
        <textarea type={type} name={name} placeholder={placeholder} id={id} className="form-control" onChange={handleInputChange}></textarea>
        </label>
        </div>
}